export default function THead({children}) {
  return (
      <thead className="bg-gray-50 dark:bg-slate-800">
      {children}
      </thead>
  )
}